export default __webpack_public_path__ + "static/l10-26edab035e9a9580f506f86056c98fd1.png";